export default __webpack_public_path__ + "f48c467.png";